// material-ui
import {} from '@mui/material'
import React from 'react'

// assets
import * as autoThunks from 'features/auto-thunks'
import { useEffect } from 'react'

import MetricGraphsComponent from 'components/MetricGraphsComponent'
import { getUserClaims } from 'features/application/application-slice'
import {
  get_all_metricCursor,
  get_selected_metricCursor,
  setSelectedmetricCursor,
} from 'features/metricCursor/metricCursor-slice'
import {
  get_all_metricDeployment,
  get_selected_metricDeployment,
  setSelectedmetricDeployment,
} from 'features/metricDeployment/metricDeployment-slice'
import {
  get_all_metricGraphScreen,
  get_selected_metricGraphScreen,
  setSelectedmetricGraphScreen,
} from 'features/metricGraphScreen/metricGraphScreen-slice'
import {
  get_all_metricPeriod,
  get_selected_metricPeriod,
  setSelectedmetricPeriod,
} from 'features/metricPeriod/metricPeriod-slice'
import { get_all_metricResult } from 'features/metricResult/metricResult-slice'
import { useDispatch, useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid
  let dispatch = useDispatch()
  let claims = useSelector(getUserClaims)
  let metricDeployment_list = useSelector(get_all_metricDeployment)
  let metricDeployment = useSelector(get_selected_metricDeployment)
  let metricGraphScreen_list = useSelector(get_all_metricGraphScreen)
  let metricGraphScreen = useSelector(get_selected_metricGraphScreen)
  let metricPeriod_list = useSelector(get_all_metricPeriod)
  let metricPeriod = useSelector(get_selected_metricPeriod)
  let metricResult_list = useSelector(get_all_metricResult)
  let metricCursor_list = useSelector(get_all_metricCursor)
  let metricCursor = useSelector(get_selected_metricCursor)
  const [metricGraphScreenArgs, setMetricGraphScreenArgs] = React.useState(null)
  const [startTime, setStartTime] = React.useState(null)
  const [endTime, setEndTime] = React.useState(null)
  const [metricDeploymentIds, setMetricDeploymentIds] = React.useState(null)

  useEffect(() => {
    if (claims?.player) {
      dispatch(
        autoThunks.get_available_metric_deployments({
          playerId: claims?.player,
        }),
      )
    }
  }, [claims?.player])
  useEffect(() => {
    if (claims?.player) {
      dispatch(
        autoThunks.load_metric_graph_screens({ playerId: claims?.player }),
      )
    }
  }, [claims?.player])
  useEffect(() => {
    if (
      claims?.player &&
      metricGraphScreenArgs?.deployments &&
      metricGraphScreenArgs?.layout
    ) {
      dispatch(
        autoThunks.store_metric_graph_screen({
          playerId: claims?.player,
          metricGraphScreen: (() => {
            function getmetricGraphScreenArgs(): any {
              return metricGraphScreenArgs
            }
            return getmetricGraphScreenArgs()
          })(),
        }),
      )
    }
  }, [claims?.player, metricGraphScreenArgs])
  useEffect(() => {
    if (claims?.player && metricDeployment?.id) {
      dispatch(
        autoThunks.get_metric_deplyoment_periods({
          playerId: claims?.player,
          metricDeploymentId: (() => {
            function get_metricDeploymentId(): string {
              return metricDeployment?.id
            }
            return get_metricDeploymentId()
          })(),
        }),
      )
    }
  }, [claims?.player, metricDeployment?.id])
  useEffect(() => {
    if (claims?.player && metricDeploymentIds?.length && startTime && endTime) {
      dispatch(
        autoThunks.get_metric_results_for_cursor({
          playerId: claims?.player,
          deploymentIds: (() => {
            function getDeploymentId(): string {
              return metricDeploymentIds
            }
            return getDeploymentId()
          })(),
          startTime: (() => {
            function getStartTime(): string {
              return startTime
            }
            return getStartTime()
          })(),
          endTime: (() => {
            function getEndTime(): string {
              return endTime
            }
            return getEndTime()
          })(),
        }),
      )
    }
  }, [claims?.player, metricDeploymentIds, startTime, endTime])
  useEffect(() => {
    if (claims?.player && metricDeployment?.id) {
      dispatch(
        autoThunks.get_metric_period_cursor({
          playerId: claims?.player,
          metricPeriodId: (() => {
            function getMetricPeriodId(): string {
              return metricPeriod?.id
            }
            return getMetricPeriodId()
          })(),
        }),
      )
    }
  }, [claims?.player, metricDeployment?.id])
  useEffect(() => {
    if (claims?.player) {
      dispatch(autoThunks.get_all_metric_cursors({ playerId: claims?.player }))
    }
  }, [claims?.player])
  useEffect(() => {
    if (claims?.player) {
      dispatch(autoThunks.get_all_metric_periods({ playerId: claims?.player }))
    }
  }, [claims?.player])
  useEffect(() => {
    if (claims?.player) {
      function setUpStartEndDate(): any {
        let seconds = 1000
        let minutes = 60 * seconds
        let hours = 60 * minutes
        let day = 24 * hours
        setStartTime(Date.now() - day)
        setEndTime(Date.now())
      }
      setUpStartEndDate()
    }
  }, [claims?.player])

  function main(comp: any): any {
    return (
      <>
        <MetricGraphsComponent
          metricDeployments={metricDeployment_list}
          metricGraphScreens={metricGraphScreen_list}
          selectedGraphScreen={metricGraphScreen}
          cursors={metricCursor_list}
          cursor={metricCursor}
          startTime={startTime}
          endTime={endTime}
          period={metricPeriod}
          periods={metricPeriod_list}
          metrics={metricResult_list}
          onFetchResults={({ startTime, endTime, deploymentIds }) => {
            setStartTime(startTime)
            setEndTime(endTime)
            setMetricDeploymentIds(deploymentIds)
          }}
          onResetCursors={() => {
            setResetArgs(Date.now())
          }}
          onSelectMetricDeployment={(id) => {
            dispatch(setSelectedmetricDeployment(id))
          }}
          onSelectPeriod={(id) => {
            dispatch(setSelectedmetricPeriod(id))
          }}
          onSelectCursor={(id) => {
            dispatch(setSelectedmetricCursor(id))
          }}
          onSelectGraphScreen={(id) => {
            dispatch(setSelectedmetricGraphScreen(id))
          }}
          onSaveGraphScreen={(graphScreen) => {
            setMetricGraphScreenArgs(graphScreen)
          }}
        />
      </>
    )
  }

  let output_main = main(null)

  return output_main
}
